import React from "react";
import Context from "../../../../context";

import {
  CustomBadges,
  CustomButton2,
  CustomIcon,
  CustomSubLogin,
  TableNullData,
  UserInformation,
} from "../../../../components";

import "./index.scss";
import Cookies from "js-cookie";
import values from "../../../../values";
import utils from "../../../../utils";
import constants from "../../../../values/constants";
import { TICKET_STATUS } from "../../../../values/dropdownItems";
import { useTranslation } from "react-i18next";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {
  const { setShowModal, setSelectedTicket } = React.useContext(
    Context.TicketScreen
  );

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(values.constants.USER.TYPE)
  );

  function onUpdate(admin: any) {
    setSelectedTicket(admin);
    setShowModal("UPDATE");
  }

  const { t } = useTranslation();

  // ========================================== JSX Content =============================================

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const onClickShowModal = (ticket: any) => {
    setSelectedTicket(ticket);
    setShowModal("SHOW_TICKET");
  };
  if (data?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="ticket-List-table-body-container">
      {data?.map((ticket: any, index: number) => (
        <tr key={`driver-list-${index}`}>
          <td>{++index}</td>
          <td>
            <UserInformation
              avatar={ticket?.user?.avatar}
              name={ticket?.user?.firstName}
              lastName={ticket?.user?.lastName}
              phoneNumber={ticket?.user?.phoneNumber}
            />
          </td>
          <td>{ticket.subject} </td>
          <td>{ticket.trackingCode} </td>
          <td>
            <CustomBadges
              type={
                ticket?.status === "IN_PROGRESS"
                  ? "warning"
                  : ticket?.status === "CLOSED"
                  ? "danger"
                  : "success"
              }
              title={t(
                TICKET_STATUS.find((item) => item?._id === ticket?.status)
                  ?.name as string
              )}
            />
          </td>
          <td>
            {utils.convertGregorianToJalali({
              date: ticket?.createAt,
              format: "jDD / jMM / jYYYY",
            })}
          </td>
          <td>
            <div className="options-wrapper">
              <CustomButton2
                title={t("view")}
                type="info"
                onClick={() => onClickShowModal(ticket)}
              />
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default Body;
